module.exports = __webpack_public_path__ + "static/img/img-presenter-men.0c0e17b.png";